import * as React from "react";
const IconWorldAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M51.2 19.2c-1.4-3.8-4.1-6.8-7.7-8.5-3.1-1.4-6.5-1.8-9.8-1l-2-5.5c-.4-1-1.2-1.9-2.2-2.3s-2.1-.4-3 0c-11.7 5.3-17.4 19-13 31.1 3.1 8.5 10.5 14.4 18.9 15.9v8.6H27c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h15.2c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3h-5.3v-8.2c2.2 0 4.3-.3 6.5-.9 1-.3 1.9-1 2.4-1.9.5-1 .6-2.1.2-3.1l-2.1-5.8c6.6-3.2 9.9-11.1 7.3-18.4M17.7 31.7c-3.6-9.7.8-20.7 10-25.2l1.8 5c-2.6 1.5-4.7 3.8-6 6.6-1.7 3.6-1.9 7.7-.5 11.5s4.1 6.8 7.7 8.5c2 .9 4.2 1.4 6.3 1.4.8 0 1.6-.1 2.4-.2l1.9 5.3c-9.8 2.3-20.1-3.2-23.6-12.9m23 2.5c-2.6 1-5.5.8-8-.3-2.5-1.2-4.5-3.3-5.4-5.9s-.8-5.5.3-8c1.2-2.5 3.3-4.5 5.9-5.4q1.8-.6 3.6-.6c1.5 0 3 .3 4.4 1 2.5 1.2 4.5 3.3 5.4 5.9 2 5.3-.8 11.3-6.2 13.3" />
  </svg>
);
export default IconWorldAlt;
